import { Dispatch } from 'react-redux';
import { getUserNotificationsAction } from './actions/GetUserNotificationsAction';
import { checkHasUnseenUserNotificationsAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { updateUserNotificationsStatusAction } from './actions/UpdateUserNotificationStatusAction';
import { updateUnreadUserNotificationsAction } from './actions/UpdateUnreadUserNotificationsAction';
import { deleteUserNotificationsAction } from './actions/DeleteUserNotification';
import { updateLastSeenUserNotificationAction } from './actions/UpdateLastSeenUserNotificationAction';

export class UserNotificationActions {

  constructor(private dispatch: Dispatch<unknown>) { }

  public getUserNotifications() {
    this.dispatch(getUserNotificationsAction());
  }

  public updateUserNotificationsStatus(ids: string[], readStatus: boolean) {
    this.dispatch(updateUserNotificationsStatusAction(ids, readStatus));
  }

  public deleteUnreadUserNotifications(ids: string[]) {
    this.dispatch(deleteUserNotificationsAction(ids));
  }

  public updateUnreadUserNotifications() {
    this.dispatch(updateUnreadUserNotificationsAction());
  }

  public checkHasUnseenUserNotifications() {
    this.dispatch(checkHasUnseenUserNotificationsAction());
  }

  public updateLastSeenUserNotification(lastSeenUserNotificationId: string) {
    this.dispatch(updateLastSeenUserNotificationAction(lastSeenUserNotificationId));
  }

  //TODO dispatch other events here like update/delete/check unseen
}
